export default "__VITE_ASSET__2WAZLWSQ__"